import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { get, set, del } from "idb-keyval";

/* ============================================================
   QUERY CLIENT
   ============================================================ */

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Los datos se consideran válidos indefinidamente.
      staleTime: Infinity,

      // No eliminar consultas inactivas de memoria.
      gcTime: Infinity,

      // Evita solicitudes innecesarias.
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,

      // Si Render está despertando, permite reintentar.
      retry: 2,

      // Espera entre reintentos.
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
    },
  },
});

/* ============================================================
   PERSISTER INDEXEDDB
   ============================================================ */

const indexedDBPersister = {
  persistClient: async (client) => {
    await set("GJ_FRIO_QUERY_CACHE", client);
  },

  restoreClient: async () => {
    return await get("GJ_FRIO_QUERY_CACHE");
  },

  removeClient: async () => {
    await del("GJ_FRIO_QUERY_CACHE");
  },
};

/* ============================================================
   PERSISTIR CACHE
   ============================================================ */

persistQueryClient({
  queryClient,
  persister: indexedDBPersister,

  // Mantener la caché durante 7 días.
  maxAge: 1000 * 60 * 60 * 24 * 7,

  // Si cambiamos la estructura de datos en el futuro,
  // podemos cambiar este valor para limpiar la caché anterior.
  buster: "gj-frio-v1",
});
